/*
 * Purpose: Block save/run actions with contextual upgrade CTA
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { toast } from 'sonner';
import {
  subscriptionFromState,
  canSaveFlows,
  canRunFlows,
  canCreateMission,
  canUseSubscriptionFeature,
  subscriptionGateMessage,
  BASIC_MAX_ACTIVE_MISSIONS,
  type SubscriptionFeature,
} from '@/lib/subscriptionPolicy';
import { useAuthStore } from '@/stores/authStore';
import { APP_ROUTES } from '@/lib/appRoutes';

function accessFromStore() {
  return subscriptionFromState(useAuthStore.getState().serverUserState);
}

export function assertCanSaveFlows(): boolean {
  const access = accessFromStore();
  if (canSaveFlows(access)) return true;
  toast.error(subscriptionGateMessage('save_flows', access), {
    action: { label: 'Choose plan', onClick: () => { window.location.href = APP_ROUTES.pricing; } },
  });
  return false;
}

export function assertCanRunFlows(): boolean {
  const access = accessFromStore();
  if (canRunFlows(access)) return true;
  toast.error(subscriptionGateMessage('run_flows', access), {
    action: { label: 'Choose plan', onClick: () => { window.location.href = APP_ROUTES.pricing; } },
  });
  return false;
}

export function assertCanCreateMission(activeCount: number): boolean {
  const access = accessFromStore();
  if (canCreateMission(access, activeCount)) return true;
  if (access.guestMode || !access.tier) {
    toast.error(subscriptionGateMessage('save_flows', access), {
      action: { label: 'Choose plan', onClick: () => { window.location.href = APP_ROUTES.pricing; } },
    });
    return false;
  }
  toast.error(`Basic plan allows up to ${BASIC_MAX_ACTIVE_MISSIONS} active missions — upgrade to Plus for unlimited.`, {
    action: { label: 'Upgrade', onClick: () => { window.location.href = APP_ROUTES.pricing; } },
  });
  return false;
}

export function assertCanUseFeature(feature: SubscriptionFeature): boolean {
  const access = accessFromStore();
  if (canUseSubscriptionFeature(access, feature)) return true;
  toast.error(subscriptionGateMessage(feature, access), {
    action: { label: 'Choose plan', onClick: () => { window.location.href = APP_ROUTES.pricing; } },
  });
  return false;
}
